import type { PropsWithChildren } from 'react'
import styled from '@emotion/styled'
import { Modal } from '@retailer-platform/shared-components'
import { Z_INDEX_FIRST } from '../../../../legacy/common/theme'
import { useSurvey } from '../RetailerSatisfactionSurveyContext'
import {
  type RetailerFeedbackSurveyPages,
  type RetailerFeedbackSurveyState,
  type RetailerFeedbackSurveyProps,
} from './RetailerFeedbackSurveyController'

const ModalContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  minWidth: '560px',
})

export const RetailerFeedbackSurveyModal = ({ children }: PropsWithChildren<{}>) => {
  const { toolProps } = useSurvey<
    RetailerFeedbackSurveyPages,
    RetailerFeedbackSurveyState,
    RetailerFeedbackSurveyProps
  >()

  return (
    <Modal
      maxWidth={960}
      maxHeight={720}
      onRequestClose={toolProps.onClose}
      isOpen={toolProps.isOpen}
      shouldCloseOnEsc
      shouldCloseOnOverlayClick
      hideCloseButton={false}
      styleOverrides={{
        content: {
          padding: 0,
          width: 'auto',
        },
        overlay: {
          zIndex: Z_INDEX_FIRST + 1,
        },
      }}
    >
      <ModalContainer>{children}</ModalContainer>
    </Modal>
  )
}
